<template>
  <div class="moneyDetail">
    <van-nav-bar
      :title="$t('m.cw_span1')"
      @click-left="onClickLeft"
      left-arrow
    ></van-nav-bar>
    <div class="content">
      <div
        class="interest_card"
        style="margin-top:50px;"
      >
        <div>
          <span> {{ yishou }}</span>
          <div>{{ $t("m.cw_span2") }}</div>
        </div>
        <div>
          <span> {{ daishou }}</span>
          <div>{{ $t("m.cw_span3") }}</div>
        </div>
        <div>
          <span> {{ numBbj.one }}</span>
          <div>{{ $t("m.cw_span6") }}</div>
        </div>
        <div>
          <span> {{ numBbj.two }}</span>
          <div>{{ $t("m.cw_span5") }}</div>
        </div>
      </div>
      <div
        style="font-size:15px;font-weight:bold; display:flex;align-items:center; height:50px; color:#333;padding-left:0px;"
      >
        <img
          src="../../assets/images/new/mingxi.png"
          style="width: 20px;height: 20px;margin-right:5px;"
          alt=""
        />
        {{ $t("m.cw_span4") }}
      </div>
      <van-list
        style="border-radius:8px;overflow: hidden;"
        v-model="loading"
        :finished="finished"
        :finished-text="$t('m.gengduo')"
        @load="onLoad"
      >
        <div class="detail_card">
          <div class="card_item" v-for="(item, index) in list" :key="index">
            <div class="c1">
              <img :src="imgs1[index % 6]" />
            </div>
            <div class="c2" style="margin-right:10px;">
              <span class="detail_text" style="font-weight:bold;">{{
                formatLogDescription(item)
              }}</span>
              <span class="c_time" style="margin-top:5px;">
                {{ item.create_time }}
              </span>
            </div>
            <div class="c3">
              <span
                class="c_money"
                :class="Number(item.type) === 2 ? 'expense' : 'income'"
              >
                {{ formatLogAmount(item) }}
              </span>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <div style="height: 50px;"></div>
  </div>
</template>

<script>
import request from "@utils/request";
// import { UserMoney } from "@/components/model";
export default {
  name: "",
  data() {
    return {
      imgs1: [
        require("../../assets/images/new/bb1.png"),
        require("../../assets/images/new/bb2.png"),
        require("../../assets/images/new/bb3.png"),
        require("../../assets/images/new/bb4.png"),
        require("../../assets/images/new/bb5.png"),
        require("../../assets/images/new/xiaoli.png")
      ],
      list: [],
      page: 0,
      loading: false,
      finished: false,
      refreshing: false,
      yishou: 0,
      daishou: 0,
      numBbj: {
        one: 0,
        two: 0
      }
    };
  },
  mounted() {
    this.$toast.loading({
      message: "数据加载中...",
      forbidClick: true,
      duration: 1500
    });
  },
  computed: {
    createDate: function() {
      return function(val) {
        let date = new Date(val * 1000);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        return y + "-" + MM + "-" + d + " " + h + ":" + m;
      };
    }
  },
  methods: {
    formatLogDescription(item) {
      const description = String(item && item.desc ? item.desc : "");
      const rewardMatch = description.match(/^购买产品-(.*)-赠送积分$/);
      return rewardMatch ? `购买奖励积分-${rewardMatch[1]}` : description;
    },
    formatLogAmount(item) {
      const amount = String(item && item.num != null ? item.num : "0").replace(
        /^[+-]/,
        ""
      );
      return `${Number(item && item.type) === 2 ? "-" : "+"}${amount}`;
    },
    async onLoad() {
      this.page = this.page + 1;
      let _this = this;

      request
        .post("/user/log/log", { page: _this.page }, { login: true })
        .then(res => {
          console.log("日利宝列表数据");
          console.log(res);
          this.numBbj.one = res.data.data.tongji.uyishou || 0;
          this.numBbj.two = res.data.data.tongji.udaishou || 0;
          this.yishou = res.data.data.tongji.yishou;
          this.daishou = res.data.data.tongji.daishou.toFixed(2);
          if (this.refreshing) {
            this.list = [];
            this.refreshing = false;
          }
          for (var i = 0; i < res.data.data.list.length; i++) {
            console.log(res.data.data.list[i]["end_time"]);
            console.log(new Date().getTime() / 1000);
            this.list.push({
              desc: res.data.data.list[i]["desc"],
              create_time: res.data.data.list[i]["created_at"],
              num: res.data.data.list[i]["num"],
              type: res.data.data.list[i]["type"]
            });
          }
          this.loading = false;

          if (res.data.data.list.length < 10) {
            this.finished = true;
          }
        })
        .catch(err => {
          this.$dialog.error(err.response.data.msg);
          this.finished = true;
          this.loading = false;
        });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    }
  },
  onClickLeft() {
    this.$router.go(-1);
  },

  filters: {
    formatDate: function(value) {
      let date = new Date(value * 1000);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
    }
  },
  components: {}
};
</script>

<style scoped lang="less">
/deep/ .van-hairline--bottom::after {
  border-bottom-width: 0px;
}
.moneyDetail /deep/ .van-nav-bar {
  box-shadow: 0 0 0 #ccc;
  background-color: rgba(0, 0, 0, 0);
}
.moneyDetail /deep/ .van-nav-bar__title {
  color: #fff;
}
.moneyDetail /deep/ .van-icon {
  color: #fff;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
  box-sizing: border-box;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}

.moneyDetail /deep/ .van-nav-bar__title {
  color: #fff;
}
.moneyDetail /deep/ .van-icon {
  color: #fff;
}

.moneyDetail {
  min-height: 100vh;
  max-height: none;
  background: #f3f6fa;
  background-position: 0px -17px;
  background-size: 100%;
  .content {
    margin-top: -46px;
    padding: 15px;
    background:
      radial-gradient(circle at 88% 30px, rgba(83, 159, 216, 0.28), transparent 110px),
      linear-gradient(150deg, #071f3b 0 175px, #f3f6fa 176px);
    .interest_card {
      padding: 20px;
      //height: 90px;
      // border-bottom: 10px solid #eff2fb;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      background-color: #fff;
      border: 1px solid rgba(39, 78, 119, 0.07);
      border-radius: 16px;
      box-shadow: 0 14px 34px rgba(17, 48, 82, 0.12);
      > div {
        width: 50%;
      }
      > div:nth-child(3) {
        margin-top: 20px;
      }
      > div:nth-child(4) {
        margin-top: 20px;
      }
      div {
        font-size: 13px;

        // display: flex;
        text-align: center;
        // align-items: center;
        span {
          margin-left: 10px;
          font-size: 21px;
          font-weight: bold;
          color: var(--bg-color);
        }
      }
    }
    .detail_card {
      overflow: hidden;
      border: 1px solid rgba(39, 78, 119, 0.07);
      border-radius: 14px;
      box-shadow: 0 9px 24px rgba(20, 53, 88, 0.065);
      .card_item {
        border-bottom: 1px solid #eee;
        display: flex;
        align-items: center;
        padding: 15px;
        background-color: #fff;

        .c1 {
          flex: 1;
          text-align: center;
          img {
            float: left;
            width: 20px;
            margin-right: 10px;
          }
        }
        .c2 {
          flex: 9;
          display: flex;
          flex-direction: column;
          .detail_text {
            font-size: 13px;
            // font-weight: 600;
            line-height: 20px;
            color: #333333;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: ellipsis;
          }
          .c_time {
            font-size: 10px;
            line-height: 18px;
            color: #999999;
          }
        }
        .c3 {
          .c_money {
            color: #df3b32;
            display: block;
            text-align: right;
          }
          .c_money.expense {
            color: #15965d;
          }
          .c_money.income {
            color: #df3b32;
          }
          margin-left: 10px;
          font-size: 17px;
          font-weight: bold;
        }
      }
      .card_item:last-child {
        border-bottom: 0px solid #eee;
      }
    }
  }
}
</style>

